/* @flow */

import * as React from 'react';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router';
import { matchRoutes } from 'react-router-config';

import { getMetadataFromComponents } from '../../../utils';
import routes from '../../routes';

function PageHelmet({
  children,
  page,
  location,
  ...props
}: {
  children: React.Node,
  page: React.ComponentType<*>,
  location: { pathname: string },
}) {
  let matches = matchRoutes(routes, location.pathname);
  let match = matches.find(({ route }) => route.component.metadata) || matches[0];

  let helmetProps = getMetadataFromComponents([page], match ? match.route : {});

  return (
    <Helmet {...helmetProps} {...props}>
      {children}
    </Helmet>
  );
}

export default withRouter(PageHelmet);



// WEBPACK FOOTER //
// ./src/ui/components/chrome/PageHelmet.js